
class CartRecommendations extends HTMLElement {
    constructor() {
        super();
        this.generateRecommendations();
    }

    generateRecommendations() {
        const cartItem = document.querySelector('#CartDrawer-Form #CartDrawer-Item-1');

        if (cartItem) {
            fetch(`${routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItem.dataset.productId}&limit=${this.dataset.limit}`)
                .then(response => response.text())
                .then(text => {
                    const innerHTML = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector('[data-js-cart-recommendations-performed]');

                    if (innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0) {
                        this.innerHTML = innerHTML.innerHTML;
                        this.initializeSwiper();
                        this.initializeAddToCartButtons();
                        if (window.handleNewProducts) {
                            window.handleNewProducts(this);
                        }
                    }
                });
        }
    }

    initializeSwiper() {

        new Swiper('.cart-recommendations-swiper', {
            slidesPerView: 2,
            spaceBetween: 10,
            centeredSlides: false,
            loop: true,
            // pagination: {
            //     el: '.swiper-pagination',
            //     clickable: true
            // },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
           
            breakpoints: {

                768: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
            },
        });

    }
    // New method to initialize add to cart buttons
    initializeAddToCartButtons() {
        const addButtons = this.querySelectorAll('.add-to-cart-button');
        const self = this; // Store a reference to the CartRecommendations instance

        addButtons.forEach((button) => {
            button.addEventListener('click', function (e) {
                e.preventDefault();

                // Get the variant ID
                const variantId = this.getAttribute('data-variant-id') || this.getAttribute('data-product-id');

                if (!variantId) {
                    console.error('No variant ID found for add to cart');
                    return;
                }

                console.log('Adding to cart variant ID:', variantId);

                // Convert to number
                const id = parseInt(variantId, 10);

                // Add to cart using Shopify AJAX API
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
                })
                    .then(response => {
                        if (!response.ok) {
                            return response.json().then(data => {
                                console.error('Error response:', data);
                                throw new Error(data.description || 'Error adding product to cart');
                            });
                        }
                        return response.json();
                    })
                    .then(data => {
                        console.log('Product added to cart successfully:', data);

                        // Use the self reference to call onCartUpdate
                        self.cartRefresh().then(() => {
                            // Open the cart drawer after updating
                            const cartDrawer = document.querySelector('cart-drawer');
                            if (cartDrawer && typeof cartDrawer.open === 'function') {
                                cartDrawer.open();
                            }
                        });
                    })
                    .catch(error => {
                        console.error('Error adding product to cart:', error);
                    });
            });
        });
    }
    // Add a static method to update the cart drawer


    async cartRefresh() {
        await window.ShopUtils.updateShippingNotices(); //global.js
        await window.ShopUtils.cartRefresh('drawer');
    }
}


customElements.define('cart-recommendations', CartRecommendations);
